// src/components/NotFound.js
import React from 'react';

const NotFound = () => {
  return (
    <div className='text-center mt-5'>
      <h1>404 - Page Not Found</h1>
      <p className='mt-2'>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;
